// extracted by mini-css-extract-plugin
module.exports = {"roles-fields":"roles-fields___34apP","label":"label___2B68k","description":"description___2IVQC","disabled":"disabled___2qM-w"};